module.exports = __webpack_public_path__ + "img/sofia_schmid_8.e1f85fee.jpg";